import { IProduct } from '@interfaces';
import VarietyPack from '@components/pages/shop/partial/variety-pack';
import { useEntity } from '@app/store/rtk.entities.selectors';
import { useState } from 'react';
import Clickable from '@v2/components/common/presentational/clickables/default';

export default function VarietyPacks({category, subscribed}: {category: any, subscribed?: boolean}) {
    const allProducts = useEntity('varietyPacks');
    const [showAll, setShowAll] = useState(false);

    return (
        <div className={`category ${category.id}`} id={`${category.id}`}>
            <div className="category-title mb-4">
                <h2>{category.title}
                    {category.pricePerMeal &&
                        <span>from ${category.pricePerMeal.toFixed(2)} per meal</span>
                    }
                </h2>
                <div>
                    <p>{category.description}</p>
                </div>
            </div>
            <div className="products">
                {
                    allProducts
                        ?
                        <div className="row">
                            {Object.values(allProducts)
                                .filter((product: IProduct, index: number) => (index < 4 && !showAll) || showAll)
                                .map((product: IProduct, index: number) =>
                                    <div key={product.id} className="col-lg-6 col-md-6 col-12 mb-4">
                                        <VarietyPack disabled={false} product={product} subscribed={subscribed} />
                                    </div>
                            )}
                            {!showAll && allProducts.length > 4 &&
                                <Clickable className="show-all-action" onClick={() => setShowAll(true)}>Show All Variety Packs</Clickable>
                            }
                        </div>
                        :
                        <div className="row"></div>
                }
            </div>
        </div>
    );
}
